import { render, staticRenderFns } from "./offerCategory.vue?vue&type=template&id=00a36d54"
import script from "./offerCategory.vue?vue&type=script&lang=js"
export * from "./offerCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports